import { Box, IconButton, Chip } from "@mui/material"
import { GridColDef } from "@mui/x-data-grid"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import moment from "moment"
import { Utility } from "src/api/modules/utilitize"

const getShipmentStatusColumns = ({
  handleEdit,
  handleDelete
}: {
  handleEdit: (row: Utility) => void
  handleDelete: (row: Utility) => void
}) => {
  const shipmentStatusColumns: GridColDef<Utility>[] = [
    {
      field: "secondaryId",
      headerName: "ID",
      width: 80
    },
    {
      field: "itemName",
      headerName: "Shipment Status Title",
      flex: 1
    },
    {
      field: "active",
      headerName: "Active",
      type: "boolean",
      flex: 1,
      renderCell: ({ value }) => (
        <Chip label={value ? "Active" : "Inactive"} color={value ? "success" : "default"} size="small" />
      )
    },
    {
      field: "additionalInformation",
      headerName: "Additional Information",
      flex: 1,
      renderCell: ({ value }) => <span title={value || ""}>{value || "-"}</span>
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY HH:mm")
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1
      // type: "singleSelect",
      // valueOptions: ["John Doe", "Jane Smith", "Alice Johnson"]
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      filterable: false,

      renderCell: ({ row }) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" onClick={() => handleEdit(row)} color="primary">
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => handleDelete(row)} color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      )
    }
  ]
  return shipmentStatusColumns
}

export default getShipmentStatusColumns
